import gql from 'graphql-tag'
export const MUTATION__ADD_TENANT = gql`mutation CreateTenantFromName($name: String) {
  newTenant: createTenantFromName(name: $name) {
    uuid
    title
    is_active
    kind
  }
}`;
